import { Field } from 'formik'
import cn from 'classnames'

import Select from 'components/Select'

import { tipConfigurationsUtils } from 'utils/tipConfigurations'
import { createRequiredLabel } from 'utils/formik'

const DefaultTipOption = ({
  tipValues,
  selectedTipOption,
  handleChangeDefaultSelectedTipOption,
  error,
  showError,
  name,
  isHeaderBold = false,
}) => {
  const tipOptions =
    tipConfigurationsUtils.generateTipOptions(tipValues)

  const defaultTipOption = tipConfigurationsUtils.getDefaultTipOpion(
    tipValues,
    selectedTipOption
  )

  const defaultSelectedTipOptionKey =
    tipConfigurationsUtils.getDefaultTipOptionKey(
      tipValues,
      selectedTipOption
    )

  return (
    <section className="content-wrapper -block -flags-wrapper">
      <h3
        className={cn('header-title', {
          '-font-regular': !isHeaderBold,
        })}
      >
        Set Default Tip Option
      </h3>
      <div className="text-field">
        <Field
          component={Select}
          key={defaultSelectedTipOptionKey}
          options={tipOptions}
          handleChange={(value) =>
            handleChangeDefaultSelectedTipOption(value)
          }
          defaultValue={defaultTipOption}
          label={createRequiredLabel('Default Tip Option')}
          name={name}
          error={error}
          showValidationErrors={showError}
          dataCy={name}
        />
        {error && showError && (
          <div className="textbox__error-msg">{error}</div>
        )}
      </div>
    </section>
  )
}

export default DefaultTipOption
